import { Clipboard } from "@angular/cdk/clipboard";
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  OnInit,
  Renderer2,
  SimpleChanges,
  ViewEncapsulation,
} from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { fuseAnimations } from "@fuse/animations";
import { HelperService } from "app/helpers/helper.service";

@Component({
  selector: "app-plain-text-dialog",
  templateUrl: "./plain-text-dialog.component.html",
  styleUrls: ["./plain-text-dialog.component.scss"],
  animations: fuseAnimations,
  encapsulation: ViewEncapsulation.None,
})
export class PlainTextDialog implements OnInit, AfterViewInit {
  data: any = [];
  text_content: string = "";

  public afterViewInit = () => {};

  constructor(
    public matDialogRef: MatDialogRef<PlainTextDialog>,
    public renderer: Renderer2,
    private cdr: ChangeDetectorRef,
    private helper: HelperService,
    private router: Router,
    private clipboard: Clipboard
  ) {}

  ngOnInit(): void {}

  ngAfterViewInit(): void {
    this.afterViewInit();
  }

  ngAfterViewChecked() {
    this.cdr.detectChanges();
  }

  onCardClick(): void {}

  ngOnChanges(changes: SimpleChanges): void {}

  get_text_content() {
    return this.text_content.replace(/\n/g, "<br>");
  }

  copyContent(event) {
    event.stopPropagation();
    this.clipboard.copy(this.text_content.replace(/\n/g, "\n"));
  }
}
